import React, { useEffect, useRef, useState ,forwardRef, useImperativeHandle} from 'react';

import '../../slider.css';
import ImageSlider from "./ImageSlider.jsx";


const Saling = ({c})=>{
  const isMobile = window.innerWidth <= 768;
  const circleStyle = {
    width: isMobile?'20px':'25px',
    height: isMobile?'20px':'25px',
    backgroundColor: c?'#60b42c':'grey',
    borderRadius: '50%',
    marginTop:isMobile?"9px":"13px"
  }; 

  const textStyle= {
    marginLeft:"8px",
    color: '#8c662f',
    fontSize : isMobile?"1.5rem":"2rem",
    fontFamily: 'AppleSDGothicNeo-Light',
  }
  if (c !== true && c !== false)return <></>;

  return (
    
    <div style={{color:"black", display:'flex', marginLeft:"30px"}}>
      <div style={circleStyle}></div>
      <span style={textStyle}>{c?"분양중":"분양완료"}</span>      
    </div>
  );
};

const Wee = ({c})=>{
  if (c === null || c === undefined || c === "")return <></>;
  const isMobile = window.innerWidth <= 768;

  return (<div style={{display:"flex", color:"#6f5c4e", fontSize:isMobile?"1.2rem":"1.5rem", marginTop:"30px"}}>
    <img src = 'free-icon-font-jar-wheat@3x.png' width={isMobile?20:30} height={isMobile?20:30} alt="wee" style={{marginTop:"3px"}}/>
    <span style={{marginLeft:isMobile?"15px":"30px"}}>위수 : {c}</span>
    

  </div>);
}


function VideoPlayer({ imgSrc, videoSrc }) {
  const isMobile = window.innerWidth <= 768;
  const [showThumbnail, setShowThumbnail] = useState(true);
  const videoRef = useRef(null);

  const handleThumbnailClick = () => {
    setShowThumbnail(false); // 썸네일 숨기기
    if (videoRef.current) {
      videoRef.current.play(); // 비디오 재생
      videoRef.current.playbackRate = 2;
    }
  };

  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);

  // 비디오 재생/일시정지 토글
  const togglePlay = () => {
    if (videoRef.current) {
      const video = videoRef.current;
      if (isPlaying) {
        video.pause();
      } else {
        video.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  // 비디오 진행률 업데이트
  const handleProgress = () => {
    if (videoRef.current) {
      const video = videoRef.current;
      const progress = (video.currentTime / video.duration) * 100;
      setProgress(progress);
    }
  };

  // 진행률 표시 막대 조절로 비디오 시간 업데이트
  const handleSeekBar = (e) => {
    const video = videoRef.current;
    const time = (e.target.value / 100) * video.duration;
    video.currentTime = time;
  };


    // 비디오의 timeupdate 이벤트 리스너 추가
    useEffect(() => {
      const video = videoRef.current;
      video.addEventListener('timeupdate', handleProgress);
      return () => {
        video.removeEventListener('timeupdate', handleProgress);
      };
    }, []);

    
  return (<>
    <div style={{display: "flex", color: "#6f5c4e", fontSize: "1.5rem", marginTop: "40px", marginLeft: "30px", marginBottom:"10px"}}>
      <img src='map-2@3x.png' width={30} height={30} alt='map' />
      <span style={{marginLeft: "20px", fontSize: "1.5rem", color: "#6f5c4e", fontFamily: "AppleSDGothicNeo-Medium"}}>오시는길</span>
    </div>
    
    

    <div style={{ 
      position: 'relative',
      width: '100%', // 부모 div의 너비 설정
      paddingTop: '56.25%', // 16:9 비율 설정
      height: 0, // 높이를 0으로 설정하여 padding-top으로 비율 조정
      overflow: 'hidden' // 내용이 넘칠 경우 숨김
    }}>
   
      {showThumbnail && imgSrc ? (
        <>
          <img
            src={imgSrc}
            alt="오시는길썸네일"
            style={{ 
              cursor: 'pointer', 
              position: 'absolute', 
              zIndex: 1,
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover' // 이미지를 부모 div에 꽉 차게 fit
            }}
            onClick={handleThumbnailClick}
          />
          <img 
            src="play-button.png"
            alt="play"
            style={{
              position: 'absolute',
              zIndex: 2, // 플레이 버튼이 썸네일 위에 오도록 함
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)', // 정확히 중앙에 위치
              width: isMobile?'100px':'200px',
              height: isMobile?'100px':'200px',
              cursor: 'pointer',
            }}
            onClick={handleThumbnailClick}
          />
        </>
      ) : null}
    
        <video 
          ref={videoRef}
          src={videoSrc}            
          loop
          muted
          playsInline
          style={{ 
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover', // 비디오를 부모 div에 꽉 차게 fit
            display: showThumbnail && imgSrc? 'none' : 'block', // 썸네일이 보일 때는 비디오 숨김
            transform: 'scale(2.5)',// translate(-50%, -50%)', // 확대 후 가운데 정렬
            //transformOrigin: 'center center' // 확대 기준점을 가운데로 설정
          }}      
        />
        <div className="video-controls" style={{ position: 'absolute', bottom: '0', background: 'rgba(0, 0, 0, 0.5)', width: '100%', padding: '10px', display: 'flex', alignItems: 'center' }}>
        <button onClick={togglePlay} style={{ background: 'transparent', border: 'none', color: 'white', fontSize: '20px' }}>
          {isPlaying ? '⏸' : '▶'} {/* 아이콘으로 변경 */}
        </button>
          <input type="range" value={progress} onChange={handleSeekBar} style={{ flexGrow: '1', margin: '0 10px' }} />
      </div>

    </div>

    </>
  );
}



const PinChild = ({ content, onLoad }) => {
  const isMobile = window.innerWidth <= 768;

  return (
    <div style={{marginBottom:"20px"}}>
      <div style={{padding:"0px 30px"}} >
       
       <div style={{marginTop:"25px", display:"flex"}}>
          <div>
            <b style={{fontSize:isMobile?"1.5rem":"2rem", color:"#8c662f",  fontFamily: 'AppleSDGothicNeo-SemiBold'}}>{content.title}</b>
          </div>

          <div style={{width:"5px", height:isMobile?"30px":"35px", backgroundColor:"#f57600", marginLeft:isMobile?"20px":"50px", marginTop:isMobile?"3px":"8px"}}></div>
          <Saling c={content["분양중"]}/>
        </div>

        <Wee c= {content["위수"]}/>

        <div className='pin-child-subtitle' style={{marginTop:"30px"}}>
          {content["subTitle"]}
        </div>
        {/* space용도 */}
        <div className='pin-child-content' style={{marginTop:"20px"}}></div>
        <div className='pin-child-content' style={{marginTop:"20px", display:"none"}}>
          {content["description"]}
        </div>
    </div>  
    <ImageSlider images={content.images} onLoad={onLoad}/>

    {content["오시는길영상"] !== null && content["오시는길영상"] !== undefined && content["오시는길영상"] !== "" &&  
     <VideoPlayer imgSrc={content["오시는길썸네일"]} videoSrc={content["오시는길영상"]}/>
    }
    </div>
    
  );
};


export default PinChild;